// extracted by mini-css-extract-plugin
export default {"wrapper":"J9bLGvjRV_6MyIeOT6ka","connectorNameWrapper":"OaSVh9IViuQkhtHL0a9i","list":"nVuGn3LYP0LKe_ty71Lx","listItem":"dXqHTjqKOhaXzQ2QXlNv"};